import { convexQuery } from '@convex-dev/react-query'
import { api } from '@cvx/_generated/api'
import type { Id } from '@cvx/_generated/dataModel'
import { useQuery } from '@tanstack/react-query'

const STAGE_LABELS: Record<string, string> = {
  applied: 'Applied',
  screening: 'Screening',
  interview: 'Interview',
  offer: 'Offer',
  hired: 'Hired',
  rejected: 'Rejected',
}

const STAGE_STYLES: Record<string, string> = {
  applied: 'bg-gray-100 text-gray-700',
  screening: 'bg-blue-100 text-blue-700',
  interview: 'bg-purple-100 text-purple-700',
  offer: 'bg-yellow-100 text-yellow-700',
  hired: 'bg-green-100 text-green-700',
  rejected: 'bg-red-100 text-red-700',
}

type Props = {
  readonly candidateId: Id<'candidates'>
}

export const PipelineStageTimeline = ({ candidateId }: Props) => {
  const { data: movements = [] } = useQuery(
    convexQuery(
      api.features.candidates.candidates.listMyPipelineStageMovements,
      { candidateId },
    ),
  )

  if (movements.length === 0) {
    return (
      <p className="text-xs text-primary/50">
        No stage movements recorded yet.
      </p>
    )
  }

  return (
    <ol className="flex flex-col gap-2">
      {movements.map((movement) => (
        <li key={movement._id} className="flex items-center gap-2 text-xs">
          <span
            className={`rounded-full px-2 py-0.5 font-medium ${STAGE_STYLES[movement.fromStage] ?? ''}`}
          >
            {STAGE_LABELS[movement.fromStage] ?? movement.fromStage}
          </span>
          <span className="text-primary/40">→</span>
          <span
            className={`rounded-full px-2 py-0.5 font-medium ${STAGE_STYLES[movement.toStage] ?? ''}`}
          >
            {STAGE_LABELS[movement.toStage] ?? movement.toStage}
          </span>
          <span className="text-primary/50">
            {new Date(movement.movedAt).toLocaleString()}
          </span>
        </li>
      ))}
    </ol>
  )
}
